import {electronicFormatIBAN, isValidIBAN, isValidBIC} from 'ibantools';
import locale from "../localization/locale"
import utils  from "./utils";
import validbarcode from "barcode-validator";
import ValidatorFactory from 'bg-egn-helper/scripts/validator';
const BGCN = require('bulgarian-control-numbers').default;
const egnValidator = new ValidatorFactory();

const number_validation = (el, value) => {
    if(value && /\D/.test(value)) {
        return Promise.reject(locale.get("form_error.number"));
    }

    return Promise.resolve()
};

const email_validation = (el, value) => {
    if(value && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
        return Promise.reject(locale.get("form_error.email"));
    }

    return Promise.resolve()
};

const float_validation = (el, value) => {
    if(value && !/^[+-]?(0|[1-9][0-9]*)([.,][0-9]+)?$/.test(value)) {
        return Promise.reject(locale.get("form_error.number"));
    }

    return Promise.resolve()
};

const phone_validation = (el, value) => {
    if(value && !/^[+]?[(]?[0-9]{2,}[)]?[-\s.]?[-\s.0-9]{4,}$/.test(value)) {
        return Promise.reject(locale.get("form_error.phone"));
    }

    return Promise.resolve()
};

const validate_pass = (el, value) => {
    if(value && value.length < 8) {
        return Promise.reject(locale.get("login.message.password_error"));
    }
    else if (value && !/[0-9]/.test(value)){
        return Promise.reject(locale.get("login.message.password_error"));
    }
    else if (value && !/[A-Z,А-Я]/.test(value)){
        return Promise.reject(locale.get("login.message.password_error"));
    }
    else if (value && !/[a-z,а-я]/.test(value)) {
        return Promise.reject(locale.get("login.message.password_error"));
    }

    return Promise.resolve()
};

const name_validation = (el, value) => {
    if(!value) {
        return Promise.reject(locale.get("login.tooltip.default"));
    }
    else if(value && value.length < 5) {
        return Promise.reject(locale.get("create_user.message.name_error"));
    }
    else if(!/[a-z,A-Z,а-я,А-Я]\s[a-z,A-Z,а-я,А-Я]/.test(value)) {
        return Promise.reject(locale.get("create_user.message.name_error"));
    }

    return Promise.resolve()
};

const value_extractor = async (form, default_value, options = {}) => {
    if (!options.noValidate) {
        try {
            await form.validateFields()
        }
        catch(e) {
            console.error("form validator error", e)
            return null
        }
    }

    let form_data = form.getFieldsValue();
    let data = {};

    Object.keys(form_data).forEach(key => {
        let value = form_data[key];
        if (value || value === false || value === 0 || value === "") {
            if (!default_value || utils.getValueFromJSON(default_value, key) !== value)
            utils.setValueInJSON(data, key, value)
        }
    });
    return data;
};

const iban_validation = (el, value) => {

    if(value) {
        value = electronicFormatIBAN(value);
        if (!isValidIBAN(value))
            return Promise.reject(locale.get("form_error.iban"));
    }

    return Promise.resolve()
};

const bic_validation = (el, value) => {

    if(value && !isValidBIC(value)) {
        return Promise.reject(locale.get("form_error.bic"));
    }

    return Promise.resolve()
};

const bulstat_validation = (el, value) => {
    if(value) {
        try {
            const bulstat = BGCN.bulstat(value);

            if (!bulstat.isValid)
                return Promise.reject(locale.get("form_error.bulstat"));

        }
        catch(e) {
            return Promise.reject(locale.get("form_error.bulstat"));
        }
    }

    return Promise.resolve()
};

const egn_validator = (el, value) => {
    if(value && !egnValidator.validate(value)) {
        return Promise.reject(locale.get("form_error:egn"));
    }

    return Promise.resolve()
}

const bulstat_egn_validator = (el, value) => {
    if(value) {
        try {
            const bulstat = BGCN.bulstat(value);

            if (bulstat.isValid)
                return Promise.resolve();
        }
        catch(e) {}
        console.log(value, egnValidator.validate(value))
        if(!egnValidator.validate(value)) {
            return Promise.reject(locale.get("form_error.bulstat_egn"));
        }
    }

    return Promise.resolve()
}

const barcode_validator = (el, value) => {
    if(value) {

        const isValid = validbarcode(value);

        if (!isValid)
            return Promise.reject(locale.get("form_error.barcode"));
    }

    return Promise.resolve()
}

const barcodeEAN13_validator = (el, value) => {
    if(value) {

        const isValid = validbarcode(value);

        if (!isValid)
            return Promise.reject(locale.get("form_error.barcode"));

        if (value.length !== 13)
            return Promise.reject(locale.get("form_error.barcode"));
    }

    return Promise.resolve()
}


const barcodeEAN8_validator = (el, value) => {
    if(value) {

        const isValid = validbarcode(value);

        if (!isValid)
            return Promise.reject(locale.get("form_error.barcode"));

        if (value.length !== 8)
            return Promise.reject(locale.get("form_error.barcode"));
    }

    return Promise.resolve()
}

const methods = {
    number_validation,
    email_validation,
    float_validation,
    phone_validation,
    name_validation,
    validate_pass,
    value_extractor,
    iban_validation,
    bic_validation,
    bulstat_validation,
    egn_validator,
    bulstat_egn_validator,
    barcode_validator,
    barcodeEAN13_validator,
    barcodeEAN8_validator
}

export default methods;
